// Automatic version checker to ensure users always have the latest version
let currentVersion = null;
let checkInterval = null;

export const startVersionCheck = () => {
  // Check version every 2 minutes
  checkInterval = setInterval(checkVersion, 120000);
  
  // Also check on page visibility change
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      checkVersion();
    }
  });
  
  // Initial check
  checkVersion();
};

export const stopVersionCheck = () => {
  if (checkInterval) {
    clearInterval(checkInterval);
    checkInterval = null;
  }
};

const checkVersion = async () => {
  try {
    // Fetch version.json with cache busting
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: 'no-store'
    });
    
    if (!response.ok) return;
    
    const data = await response.json();
    
    if (!currentVersion) {
      // First check - store current version
      currentVersion = data.version;
      return;
    }
    
    // Check if version has changed
    if (data.version !== currentVersion) {
      console.log('New version available:', data.version, '(current:', currentVersion + ')');
      
      // Clear service worker cache
      if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: 'SKIP_WAITING'
        });
      }
      
      // Clear all caches
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
      }
      
      // Reload page to get new version
      window.location.reload();
    }
  } catch (error) {
    console.error('Version check failed:', error);
  }
};
